import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37f856d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-theme"];
const _hoisted_2 = {
    key: 0,
    class: "Nav flex-1"
};
const _hoisted_3 = { class: "flex items-center gap-24" };
import { ref, computed } from "vue";
import { useAppState, useStoryContext } from "@/services/Composition";
import Viewport from "@/store/modules/Viewport";
import Delay from "@/core/Delay";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppFooter',
    props: {
        theme: { default: "dark" }
    },
    setup(__props) {
        const props = __props;
        const { state, send } = useAppState();
        const isStoryMenuOpen = useStoryContext("isMenuOpen");
        const sharekey = ref("label");
        const showNav = computed(() => ["home.home.page.default", "home.home.page.enterExperience"].some(state.value.matches));
        function goto(page) {
            switch (page) {
                case "about":
                    send("GO_TO_ABOUT");
                    break;
                case "credits":
                    send("GO_TO_END");
                    break;
            }
        }
        function share() {
            const url = window.location.href;
            Viewport.hasNativeShare ? doNativeShare(url) : copyURL(url);
        }
        async function doNativeShare(url) {
            const data = { url };
            try {
                await navigator.share(data);
            }
            catch (err) {
                console.error("Failed to share: ", err);
            }
        }
        async function copyURL(url) {
            try {
                navigator.clipboard.writeText(url);
                sharekey.value = "url_copied";
                await Delay(1000);
                sharekey.value = "label";
            }
            catch (err) {
                console.error("Failed to copy: ", err);
            }
        }
        function onHoverShare({ type }) {
            if (Viewport.hasNativeShare)
                return;
            if (sharekey.value === "url_copied")
                return;
            const isHover = type === "mouseenter";
            sharekey.value = isHover ? "copy_url" : "label";
        }
        return (_ctx, _cache) => {
            const _component_AppSoundToggle = _resolveComponent("AppSoundToggle");
            const _component_UIBtn = _resolveComponent("UIBtn");
            return (_openBlock(), _createBlock(_Transition, {
                name: "fade",
                appear: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("footer", {
                        class: "AppFooter flex justify-end lg:justify-start items-center gap-40 lg:h-32",
                        "data-theme": _ctx.theme
                    }, [
                        _withDirectives(_createVNode(_component_AppSoundToggle, {
                            class: "relative z-1",
                            theme: _ctx.theme
                        }, null, 8, ["theme"]), [
                            [_vShow, _unref(Viewport).isDesktop || _unref(isStoryMenuOpen)]
                        ]),
                        _createVNode(_Transition, {
                            name: "fade",
                            appear: ""
                        }, {
                            default: _withCtx(() => [
                                (showNav.value)
                                    ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
                                        _createElementVNode("ul", _hoisted_3, [
                                            _createElementVNode("li", null, [
                                                _createVNode(_component_UIBtn, {
                                                    as: "a",
                                                    href: "#about",
                                                    appear: false,
                                                    theme: _ctx.theme,
                                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goto('about')), ["prevent"]))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("footer.nav.about")), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["theme"])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createVNode(_component_UIBtn, {
                                                    as: "a",
                                                    href: "#credits",
                                                    appear: false,
                                                    theme: _ctx.theme,
                                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (goto('credits')), ["prevent"]))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("footer.nav.credits")), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["theme"])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createVNode(_component_UIBtn, {
                                                    as: "a",
                                                    href: "https://www.claimscon.org/about/privacy-policy/",
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    appear: false,
                                                    theme: _ctx.theme
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("footer.nav.legals")), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["theme"])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createVNode(_component_UIBtn, {
                                                    as: "a",
                                                    href: "#share",
                                                    appear: false,
                                                    theme: _ctx.theme,
                                                    onMouseenter: onHoverShare,
                                                    onMouseleave: onHoverShare,
                                                    onClick: _withModifiers(share, ["prevent"])
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t(`footer.nav.share.${sharekey.value}`)), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["theme"])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ], 8, _hoisted_1)
                ]),
                _: 1
            }));
        };
    }
});
